export default {
  visableCount: {
    textAlign: 'center',
    fontSize: '12px',
    mb: 16
  }
};